import { ViewStyle, TouchableOpacity, TouchableOpacityProps, ActivityIndicator } from "react-native"
import { Text } from "./Typography"
import { functionalColors } from "./colors"
import { useTheme } from "@emotion/react"

type Variants = "blue" | "blue2" | "blue3" | "white" | "zumthor"

type ButtonProps = TouchableOpacityProps & {
  variant?: Variants
  title: string
  loading?: boolean
  textColor?: keyof (typeof functionalColors)["text"]
  customHeight?: number
  customBackgroundColor?: keyof (typeof functionalColors)["text"]
}

export function ButtonV2(props: ButtonProps) {
  const { variant = "blue", title, loading, textColor, customHeight, customBackgroundColor } = props
  const theme = useTheme()

  const wrapperStyles: { [buttonType in Variants]: ViewStyle } = {
    blue: {
      width: "100%",
      height: 66,
      backgroundColor: functionalColors.v2.components.buttons.blue.backgroundColor,
      borderRadius: 100,
      alignItems: "center",
      justifyContent: "center",
    },
    blue2: {
      width: "100%",
      height: 66,
      backgroundColor: functionalColors.v2.components.buttons.blue2.backgroundColor,
      borderRadius: 100,
      alignItems: "center",
      justifyContent: "center",
    },
    blue3: {
      width: "100%",
      height: 66,
      backgroundColor: functionalColors.v2.components.buttons.blue3.backgroundColor,
      borderRadius: 100,
      alignItems: "center",
      justifyContent: "center",
    },
    white: {
      width: "100%",
      height: 66,
      backgroundColor: functionalColors.v2.components.buttons.white.backgroundColor,
      borderRadius: 100,
      alignItems: "center",
      justifyContent: "center",
      borderWidth: 1,
      borderColor: functionalColors.button.secondary.borderColor,
    },
    zumthor: {
      width: "100%",
      height: 66,
      backgroundColor: functionalColors.v2.components.buttons.zumthor.backgroundColor,
      borderRadius: 100,
      alignItems: "center",
      justifyContent: "center",
    },
  }
  const defaultTextColor: { [variant in Variants]: keyof (typeof functionalColors)["text"] } = {
    blue: functionalColors.v2.components.buttons.blue.textColor,
    blue2: functionalColors.v2.components.buttons.blue2.textColor,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    white: functionalColors.v2.components.buttons.white.textColor,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    zumthor: functionalColors.v2.components.buttons.zumthor.textColor,
  }
  let containerStyles = {}
  if (variant && wrapperStyles[variant]) {
    containerStyles = {
      ...containerStyles,
      ...wrapperStyles[variant],
    }
  }
  if (customHeight) {
    containerStyles = {
      ...containerStyles,
      height: customHeight,
    }
  }
  if (customBackgroundColor) {
    containerStyles = {
      ...containerStyles,
      backgroundColor: theme.text[customBackgroundColor],
    }
  }

  return (
    <TouchableOpacity
      {...props}
      accessibilityRole={props.accessibilityRole || "button"}
      accessibilityLabel={props.accessibilityLabel ?? title}
      disabled={props.disabled || props.loading}
      style={containerStyles}
    >
      <Text
        fontSize={20}
        lineHeight={26}
        color={textColor || defaultTextColor[variant]}
        fontFamily="IBMPlexSans-Medium"
      >
        {loading ? <ActivityIndicator size="small" /> : title}
      </Text>
    </TouchableOpacity>
  )
}
